import app from '$$app';
import { api } from '$$store/api';
import rights from '../../components/rights';

let webhooks = {};

if (app.config.mode.isBase) {
  webhooks = new webix.DataCollection();

  webhooks.getData = function () {
    const data = webhooks.serialize(true);

    data.sort((a, b) => {
      if (a.id > b.id) return -1;
      if (a.id < b.id) return 1;

      return 0;
    });

    return data;
  };

  webhooks.create = function (url) {
    return webix.ajax().post('/api/team/webhooks', { url }, response => {
      const data = JSON.parse(response);

      if (data && data.webhook) {
        webhooks.add(data.webhook);
      }
    });
  };

  webhooks.delete = function (id) {
    return webix.ajax().del('/api/team/webhooks', { id }, response => {
      const data = JSON.parse(response);

      if (data && data.status) {
        webhooks.remove(id);
      }
    });
  };

  webhooks.reconnect = function (id) {
    webix.ajax().post('/api/team/webhooks/reconnect', { id }, response => {
      const data = JSON.parse(response);

      if (data && data.status) {
        const item = webhooks.getItem(id);

        item.error_count = 0;
        webhooks.updateItem(id, item);
      }
    });
  };

  webhooks.attachEvent('onAfterDelete', id => {
    app.trigger('webhooks:updated');
  });

  webhooks.attachEvent('onAfterAdd', id => {
    app.trigger('webhooks:updated');
  });

  webhooks.attachEvent('onDataUpdate', id => {
    app.trigger('webhooks:updated');
  });

  app.on('app:start', () => {
    // if (!rights.account.hasRight('webhooks_settings')) {
    //   webhooks.parse([]);
    //
    //   return false;
    // }

    api.get(`/team/webhooks?${new Date().getTime()}`).then(response => {
      webhooks.parse(response.data);
    }).catch(() => {
      webhooks.parse([]);
    });
  });
}

export default webhooks;
